import React from "react";
const EmptyLayout: React.FunctionComponent<React.PropsWithChildren> = ({
  children,
}) => {
  return <>{children}</>;
};
export default EmptyLayout;
